
















import Vue from "vue";
import SettingItemSwitch from "@/components/SettingItemSwitch.vue";
import { setLS } from "@/services";
import { StorageType } from "@/models/StorageType";

export default Vue.extend({
  components: {
    SettingItemSwitch,
  },
  computed: {
    initialClockMode(): boolean {
      return this.$store.state.clockMode;
    },
    initialColonMode(): boolean {
      return this.$store.state.colonMode;
    },
  },
  methods: {
    clockModeChange(turnOn: boolean): void {
      setLS(StorageType.CLOCKMODE, JSON.stringify(turnOn));
    },
    colonModeChange(turnOn: boolean): void {
      setLS(StorageType.COLONMODE, JSON.stringify(turnOn));
    },
  },
});
